import { Box, makeStyles } from '@material-ui/core';
import { highlight, languages } from "prismjs/components/prism-core";
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Editor from "react-simple-code-editor";
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import CustomizedSnackbars from "../../components/snackbar/Snackbar";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    contentWrapper: {
        height: "100%"
    }
})

function JSONEditor(props) {

    const classes = useStyles()
    const [t, i18n] = useTranslation()

    const [updatedJSONData, setUpdatedJSONData] = useState(props.data)
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState("")

    useEffect(() => {
        setUpdatedJSONData(props.data)
    }, [props.data])

    useEffect(() => {
        var { isEditing } = props
        if (!isEditing) {
            setUpdatedJSONData(props.data)
        }
    }, [props.isEditing])

    function confirmUpdateModal() {

        return (
            <AlertDialog
                isOpen={props.dialogOpen}
                handleClose={handleCloseDialog}
                title={props.dialogTitle}
                description={props.dialogMessage}
                options={[
                    {
                        key: "Cancel",
                        action: handleCloseDialog,
                        label: t('common.cancel')
                    },
                    {
                        key: "Save",
                        action: handleUpdate,
                        label: t('common.save')
                    }
                ]
                }
            />
        )
    }

    function handleUpdate() {
        props.handleUpdate(updatedJSONData)
    }

    function handleCloseDialog() {
        setUpdatedJSONData(props.data)
        props.handleCloseDialog()
    }

    return (
        <Box className={classes.contentWrapper}>

            {confirmUpdateModal()}

            <CustomizedSnackbars
                handleClose={() => setSnackbarOpen(false)}
                open={snackbarOpen}
                variant="error"
                message={snackbarMessage}
            />

            <Editor
            
                value={updatedJSONData}
                onValueChange={updatedJSONData => {
                    if (props.isEditing) {
                        setUpdatedJSONData(updatedJSONData);
                    }
                }}
                highlight={updatedJSONData => highlight(updatedJSONData, languages.json)}
                padding={10}
                tabSize={4}
                className="container__editor"
            />
        </Box>
    )
}

JSONEditor.propTypes = {
    data: PropTypes.string,
    isEditing: PropTypes.bool,
    handleCloseDialog: PropTypes.func,
    handleUpdate: PropTypes.func,
    dialogOpen: PropTypes.bool,
    dialogTitle: PropTypes.string,
    dialogMessage: PropTypes.string
}

export default JSONEditor

